<template>
  <ul v-if="errors !== null" class="text-xs" :class="errorContainerClass">
    <li v-for="(msg, idx) in errorFormat()" :key="idx" :class="errorClass">
      {{ msg }}
    </li>
  </ul>
</template>

<script>
export default {
  name: "RpmInputErrorList",
  props: {
    errors: {
      type: Array,
      default: null,
    },
    errorContainerClass: {
      type: [String, Array, Object],
      default: "",
    },
    errorClass: {
      type: [String, Array, Object],
      default: "text-red-500/80",
    },
  },
  methods: {
    errorFormat() {
      if (typeof this.errors != "object") return [this.errors];
      return this.errors;
    },
    isInvalid(){
      return this.error && (
        (Array.isArray(this.error) && this.error.length > 0) ||
        (typeof this.error === 'string' && this.error != '')
      );
    }
  },
  watch: {
    errors(val) {
      this.$emit("is-invalid", this.isInvalid());
    },
  },
};
</script>
